export enum CommandCenterFilter {
  JOBS_LIVE = 'jobsLive',
  JOBS_NOT_STARTED = 'jobsNotStarted',
  JOBS_COMPLETED = 'jobsCompleted',
  JOBS_WITH_MAJOR_HAZARD = 'jobsWithMajorHazards',
  JOBS_WITHOUT_VRAS = 'jobsWithoutVras',
  JOBS_WITH_UNRESOLVED_BLOCKERS = 'jobsWithUnresolvedBlockers',
}
